import { render, staticRenderFns } from "./Meta.vue?vue&type=template&id=5f4470e4&scoped=true"
import script from "./Meta.vue?vue&type=script&lang=js"
export * from "./Meta.vue?vue&type=script&lang=js"
import style0 from "./Meta.vue?vue&type=style&index=0&id=5f4470e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4470e4",
  null
  
)

export default component.exports